"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseApiDates = exports.parseApiItemToZonedDateTimeOrLocalDate = void 0;
const tslib_1 = require("tslib");
const moment_timezone_1 = tslib_1.__importDefault(require("moment-timezone"));
const local_date_1 = require("./local-date");
const utils_1 = require("./utils");
const zoned_date_time_1 = require("./zoned-date-time");
function parseApiItemToZonedDateTimeOrLocalDate(item) {
    // FIXME: MLSUP-30262 restore LocalDateTime handling when activating LocalDateTime everywhere
    // NOTE: rudimentary date-string check to avoid regex-check of all string
    if (typeof item === 'string' && item.length > 1 && /^[0-9]/.test(item[0])) {
        if (utils_1.regExTypeDateTime.test(item)) {
            return (0, zoned_date_time_1.toRawZonedDateTime)(item);
        }
        if (utils_1.regExTypeDate.test(item)) {
            return (0, local_date_1.toLocalDate)(item);
        }
    }
    if (moment_timezone_1.default.isMoment(item)) {
        const { format, input } = item.creationData();
        (0, utils_1.assertDateVariant)(input);
        if (typeof format === 'string') {
            if (format === 'YYYY-MM-DD') {
                return (0, local_date_1.toLocalDate)(input);
            }
            if (format.startsWith('YYYY-MM-DD')) {
                return (0, zoned_date_time_1.toRawZonedDateTime)(input);
            }
        }
    }
    return undefined;
}
exports.parseApiItemToZonedDateTimeOrLocalDate = parseApiItemToZonedDateTimeOrLocalDate;
/**
 * Convert date-strings to `LocalDate` or `ZonedDateTime`.
 *
 * @param dateProps defined which props shall be parsed as ZonedDateTime / LocalDate
 */
const parseApiDates = (item, dateProps) => {
    const date = parseApiItemToZonedDateTimeOrLocalDate(item);
    if (date) {
        return date;
    }
    if (Array.isArray(item)) {
        return item.map((val) => (0, exports.parseApiDates)(val, dateProps));
    }
    if (typeof item === 'object' && item) {
        return dateProps.reduce((item, [key]) => {
            const value = item[key];
            if (!value) {
                return item;
            }
            const propsWithSameFirstKey = dateProps.filter(([firstKey]) => firstKey === key);
            return Object.assign(Object.assign({}, item), { [key]: (0, exports.parseApiDates)(value, propsWithSameFirstKey.reduce((memo, props) => {
                    const newProps = [...props];
                    if (newProps.includes('*')) {
                        memo.push(...propsWithSameFirstKey);
                    }
                    else {
                        newProps.shift();
                        memo.push(newProps);
                    }
                    return memo;
                }, [])) });
        }, item);
    }
    return item;
};
exports.parseApiDates = parseApiDates;
